<template>
  <main>
    <Header :loginSource="loginSource"></Header>

    <section v-if="courseWrapper.course" class="merchant_container">
      <div class="merchant_wrapper">
        <div class="order_title">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/course', query: {no: no, activeName: 'third'} }">返回上一页</el-breadcrumb-item>
            <el-breadcrumb-item>订单确认</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <hr>
        <div class="merchant_block">
          <div class="merchant_content">
            <img class="storefront_image" :src="courseWrapper.course.coverPic" >
            <div class="merchant_desc">
              <div class="merchant_name">{{courseWrapper.course.name}}</div>
              <br>
              <div class="merchant_higher_price">原价：￥{{courseWrapper.course.originalPrice}}</div>
              <div class="merchant_lower_price">应付：￥{{courseWrapper.course.realPrice}}</div>
              <div class="merchant_lower_price">数量：<i class="el-icon-close"></i>1</div>
            </div>
          </div>
          <hr>
        </div>

        <div class="pay_wrapper">
          <div class="pay_title">支付方式</div>
          <div class="pay_box">
            <img style="width: 30px; height: 30px; margin-top: 10px; margin-bottom: 6px;" src="/static/images/test/wxpay.png">
            <span style="margin-left: 10px; margin-top: 14px; color: #333;">微信支付</span>
          </div>
          <p class="pay_tips"><i class="el-icon-info"></i> 本商品为虚拟内容服务，购买后不支持退款、转让。</p>
          <p class="pay_tips"><i class="el-icon-info"></i> 严格保障付费用户的合法权益，如果遇到支付方面的问题，可以在微信支付账单中获取到我们的联系电话，我们会竭尽所能为您解决。</p>
        </div>

        <div class="pay_button_wrapper">
          <el-button class="pay_button" type="warning" round icon="el-icon-shopping-cart-2" @click="buyCourse()">确认支付</el-button>
        </div>
      </div>

    </section>

    <Footer></Footer>
  </main>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import {mapGetters, mapState} from 'vuex'
import {
  reqSaveOrder
} from '@/api'

export default {
  name: 'OrderConfirm',
  components: {Header, Footer},
  comments: {
    Header
  },

  data() {
    return {
      no: parseInt(this.$route.query.no), // 课程编号
      loginSource: 2*1000 + parseInt(this.$route.query.no),
    }
  },

  async mounted () {
    if (!this.isLogin) {
      await this.$router.push('/index')
      return
    }
    if (!this.no) {
      await this.$router.push('/index')
    }
    if (!this.courseWrapper.course) {
      await this.$router.push('/index')
    }

  },

  methods: {
    async buyCourse (index) {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const result = await reqSaveOrder(this.no, this.courseWrapper.course.name)
      loading.close()
      if (result.code === 0) {
        const payInfo = result.data
        await this.$store.dispatch('setPayInfo', {payInfo})

        this.$router.push({
          path: '/pay'
        }).catch(err=>{})
      } else {
        await this.$alert("支付异常，请稍后再试", '错误', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
      }

    },
  },

  computed: {
    ...mapState(['courseWrapper']),
    ...mapGetters(['isLogin']),
  }

}
</script>

<style scoped>

  main {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .logo_search_container {
    display: flex;
    width: 100%;
    margin: 0px auto;
  }

  .logo_search_container > img {
    width: 1000px;
    /*width: 65vw;*/
    height: 500px;
    margin: auto;
  }

  .merchant_container {
    display: flex;
    flex-direction: column;
    width: 100%;
    /*background: #eee;*/
  }

  .tabs_wrapper {
    width: 1000px;
    /*width: 960px;*/
    /*width: 65vw;*/
    margin: 0px auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    /*padding: 0 20px;*/
  }

  .merchant_wrapper {
    width: 1000px;
    /*width: 960px;*/
    /*width: 65vw;*/
    margin: 0px auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    /*padding: 0 20px;*/
  }

  .order_title {
    /*line-height: 40px;*/
    margin-top: 20px;
    font-size: 18px;
    font-weight: 500;
  }

  hr {
    border: 1px solid #eee;
    width: 100%;
    margin: 20px 0;
  }

  .merchant_content {
    display: flex;
  }

  .storefront_image {
    width: 320px;
    height: 260px;
    border-radius: 6px;
    margin-right: 20px;
    cursor: pointer;
    border: 1px solid;
  }

  .merchant_desc {
    display: flex;
    flex-direction: column;
  }

  .merchant_name {
    /*cursor: pointer;*/
  }

  .merchant_desc div:first-child {
    font-size: 24px;
    color: #000;
    font-weight: bold;
  }

  .merchant_desc div {
    line-height: 30px;
    /*font-size: 14px;*/
    /*color: #999;*/
  }

  .course_desc {
    font-size: 16px;
    line-height: 30px;
    color: #333;
  }

  .merchant_item {
    font-size: 14px;
    color: #666;
  }

  .merchant_higher_price {
    font-size: 16px;
    color: #999;
    text-decoration:line-through;
  }

  .merchant_lower_price {
    font-size: 18px;
    color: #333;
    font-weight: bold;
  }

  .pay_wrapper {
    /*border: 1px solid red;*/
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }

  .pay_title {
    font-size: 18px;
    color: #333;
    line-height: 24px;
    font-weight: bold;
  }

  .pay_box {
    width: 160px;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 8px;
    border: 1px solid #FF9933;
    display: flex;
    flex-direction: row;
  }

  .pay_tips {
    font-size: 12px;
    color: #999;
  }

  .pay_button_wrapper {
    display: flex;
    justify-content: right;
    margin-bottom: 140px;
  }

  .pay_button {
    margin-left: 30px;
    height: 40px;
  }

  /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
    background: #99CCFF !important;
    cursor:pointer !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/OrderConfirm/OrderConfirm.vue